module.exports = __webpack_public_path__ + "img/PatientXChange_LogoWhite.04eb807f.svg";